module.exports = __webpack_public_path__ + "static/media/thumb_up.b46430d8.svg";